export function inViewport() {
  const animatedElements = document.querySelectorAll(
    '._js_inViewport, .__js_preload, .section-fixed, .section-wideo'
  );

  const hero = document.querySelector('.intro__full_img.__js_preload');
  const evenArticles = document.querySelectorAll('article:nth-of-type(2n)');

  function setSidebarOffset() {
    if (!hero) return;
    const heroBottom = hero.getBoundingClientRect().bottom;
    const offset = heroBottom > 0 ? heroBottom : 0;

    evenArticles.forEach(article => {
      article.style.setProperty('--sidebar-offset', offset + 'px');
    });
  }

  setSidebarOffset();

  const obsCallback = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('_js_inViewport')) {
          entry.target.classList.add('__js_onScreen');
        }
        if (entry.target.classList.contains('__js_preload')) {
          const srcS = entry.target.getAttribute('data-src');
          entry.target.style.opacity = '0.3';
          entry.target.setAttribute('src', srcS);
          entry.target.style.opacity = '1';
          entry.target.classList.remove('__js_preload');
          observer.unobserve(entry.target);
        }
        if (entry.target.classList.contains('section-fixed')) {
          entry.target
            .querySelector('.img-fixed-bg')
            .classList.add('fullpage-fixed');
        }
        if (entry.target.classList.contains('section-wideo')) {
          entry.target
            .querySelector('.article__wideo')
            .classList.add('wideo-fixed');
        }
      } else {
        if (
          entry.target.classList.contains('_js_inViewport') &&
          entry.target.classList.contains('__js_onScreen')
        ) {
          // entry.target.classList.remove('__js_onScreen');
          observer.unobserve(entry.target);
        }
        if (entry.target.classList.contains('section-fixed')) {
          entry.target
            .querySelector('.img-fixed-bg')
            .classList.remove('fullpage-fixed');
        }
        if (entry.target.classList.contains('section-wideo')) {
          entry.target
            .querySelector('.article__wideo')
            .classList.remove('wideo-fixed');
        }
      }
    });
  };

  const windowH = `${(window.innerHeight - 100) * -1}px`;

  const observer = new IntersectionObserver(obsCallback, {
    root: null,
    threshold: 0,
    //rootMargin: '-10px',
  });

  animatedElements.forEach((elem) => {
    observer.observe(elem);
  });
}
